// 技术分享

export default {
  sharingList: [
    // 2019 年
    {
      id: 0,
      img: require('@/assets/images/sharing/sharing_116.jpg'),
      time: {
        year: '2018',
        month: '05/03'
      },
      name: '人人都该知道的锂电池安全使用须知',
      detail: '“锂电池”应用早已无形渗透在日常生活中，小到可携式的电子产品如耳机、手机、移动电源，大到交通运输工具如电动汽车等的大小锂电池，可谓新型态的“锂生活”已正式来临！然而，锂电池的安全状况不断，尽管透过安全标准的要求可以大幅降低电池安全的问题，但要达到完全杜绝锂电池起火仍是非常困难！',
      html: [
        '“锂电池”应用早已无形渗透在日常生活中，小到可携式的电子产品如耳机、手机、移动电源，大到交通运输工具如电动汽车等的大小锂电池，可谓新型态的“锂生活”已正式来临！然而，锂电池的安全状况不断，尽管透过安全标准的要求可以大幅降低电池安全的问题，但要达到完全杜绝锂电池起火仍是非常困难！',
        '锂电池为什么危险？从锂电池的基本运行原理中就可窥知一二。市面上绝大部分锂电池的主要成分除了正负极材料外，还有电解液与隔离膜。这些材料与结构的特殊组合造成了锂离子能在电池正负极中来回，形成充电与放电的作用。然而这些材料本身在高温下具有不稳定的特性，一旦遇到内短路或是其他情况引起的高温，就可以分解出构成燃烧的要件：氧与可燃物。若是这样产生的热无法散去，就会在电池内部持续循环加速反应，产生所谓的“热失控”，顾名思义就表示了这样的失效无法控制，相当危险。',
        '随着锂电池的应用层面广，安全疑虑也因此扩大。一般手机仅使用了单颗电池，但电动车、储能系统等应用，动辄使用上千颗、上万颗，倘若一颗失效，就可能发生像是放鞭炮一样的连锁效应，一个接着一个，造成严重的伤害与损失。因此，UL研发技术总监王凯鲁提醒，“千万不可以假设锂电池一定是没有问题的，要使用锂电池，就必须了解它有一定的失效风险。”而锂电池的用料、结构、系统设计绝对会影响热失控发生时的严重性。',
        'UL以三星Note7起火与波音787飞安事件的电池失效调查发现为例，剖析电池失效事故的原因。三星Note7电池问题，主要是来自两家不同的电池供货商在制程品管上分别发生问题。其一是在电池组装过程中，锂电池角落受压力变形，造成隔离膜无法有效阻隔正负极，而产生内部短路；另一则是锂电池极耳的超音波焊点突出部位未贴上绝缘胶带，造成内部短路起火，导致产品全面下架回收。而波音787的锂电池则是由于铆钉的设计，受到飞机引擎与起降等震动使其接触不良，在高电流下使得局部发热造成隔离膜融化，同时系统设计未考虑电芯间泄压阀与失效热传递的影响，造成2013年在一个月内发生两起的飞安事件。',
        '总观而言，UL提出锂电池会出问题的真正原因有二，一是在设计产品时，把电池当成了一般组件使用，但不同于以前的传统电池，锂电池本身存在不可抗的热失控问题必须被彻底了解，电池的质量也须进行严格控管；另亦没有考虑到什么样的环境下使用才安全，做出最适当的要求；二则是没有对电池失效做出最坏情况的打算，忽略了失效所可能产生的风险与严重性。经深入分析后，这两个案例也开始重新思考看待锂电池的方式。三星从加强质量管控下手，也彻底去评估电池安全范围与失效后的损害。而波音则接受了电池会热失控的现实，从系统端着手改善，利用设计去缓解电池热失控后的失效蔓延。',
        '锂电池确实存在不可控的潜在危险！因此，UL呼吁对于锂电池的安全要有新的思维模式，若要应用锂电池在产品上，就必须认清现实，锂电池一定有安全风险，不能当作一般组件使用，要懂得如何要求电池的安全性，一方面从质量把关着手，降低出问题的机率，一方面从设计着手，充分了解电池的特性，考虑安全使用范围，并思考可能失效的方式与严重程度，将缓解失效的模式设计出来，降低电池失效的严重性。此外，UL认为预测失效相当重要，王博士重申，电池系统的失效模式应该是被“设计”出来的，完善的失效模式设计可以降低伤害的严重性。波音787的新电池设计就是最好的例子，将产生热失控的热能透过导管排到机身外，降低失效的严重性，有效控制失效后的损害。',
        'UL今年推出最新版针对储能系统的UL 9540A 测试方法标准，由于锂电池是目前储能系统的首选，随着美国纽约地区核能电厂陆续退役，为缓解电力需求，开始规画于大楼内自建储能系统，但因锂电池本身存在不可控的失效问题，因此不同于以往，推出新的测试方法，并从考虑最坏的情况出发，直接评估储能电池在热失控起火后的燃烧情况，在安装储能系统时，由系统厂商提供给当地消防人员，藉此了解该储能电池系统在热失控下的火灾特性，进而提供消防系统设计出应对方法的依据。',
        '从基本的电池芯标准ANSI/UL 1642、电池组标准ANSI/UL 2054，延伸到发展各领域如移动电源、平衡车、电动车、储能对应标准。在储能领域，从第一代固定电池组标准ANSI/CAN UL 1973、到全球第一本储能系统标准ANSI/CAN UL 9540，以及最新出版的UL 9540A测试方法。面对锂电池，UL也以新思维因应，要求了解锂电池的应用特性，提出层层防护的安全要求。王凯鲁并以航空业者举例，对于货机机师来说，相较于单颗引擎的故障，更怕货舱传出的“失火警报”！不仅要考虑到机上消防设备有可能不足以应付的火势，更要考虑到迫降及排泄燃油对于环境的问题。因此航空业者对于“锂电池的飞安”新思维也转向了解热失效的燃烧状况，提出相对应的消防设计与防护应对。',
        '锂电池确确实实存在的安全问题。除了制造商必须认清及防范使用锂电池可能带来的安全风险外，一般消费大众也同样有责任，必须正视锂电池的危险，了解如何安全使用，像是搭乘飞机，就必须遵守将锂电池产品置放在随身手提行李中，以减少飞安问题的产生。也因此，唯有每一个人都有安全共识，才能降低锂电池发生意外带来的伤害。'
      ]
    }
    // {
    //   img: require('@/assets/images/news.jpg'),
    //   time: {
    //     year: '2019',
    //     month: '06/11'
    //   },
    //   name: '英特尔10nm桌面计算机CPU再次延期',
    //   detail: '有一份标榜是英特尔(Intel)中央处理器(CPU)产品发展蓝图数据，该数据显示英特尔在2022年之前不会提供10奈米(nm)桌面计算机CPU。然而，英特尔拒绝评论所谓被泄漏的产品蓝图。荷兰IT新闻网站Tweakers发布了据称是英特尔客户端(client)CPU产品蓝图。'
    // },
    // {
    //   img: require('@/assets/images/news.jpg'),
    //   time: {
    //     year: '2019',
    //     month: '06/11'
    //   },
    //   name: 'Wi-Fi 6准备进军智能工厂应用',
    //   detail: '产业组织无线宽带联盟(Wireless Broadband Alliance，WBA)准备在英国一座飞机零件制造厂展示利用最新802.11ax 标准Wi-Fi设备的自动化营运优势，这是该技术几个准备在今年展开的试营运计划中的第一个，将在市场上与5G蜂巢式技术阵营较劲。'
    // },
    // {
    //   img: require('@/assets/images/news.jpg'),
    //   time: {
    //     year: '2019',
    //     month: '06/11'
    //   },
    //   name: '苹果为何不用iPhone XS抢5G首发？',
    //   detail: '根据市场研究公司IC Insights的调查报告，过去几年来，全球半导体产业频繁发生大规模并购的时代可能已经达到高峰了，至少在交易规模方面确实如此。'
    // },
    // {
    //   img: require('@/assets/images/news.jpg'),
    //   time: {
    //     year: '2019',
    //     month: '06/11'
    //   },
    //   name: '英特尔10nm桌面计算机CPU再次延期',
    //   detail: '有一份标榜是英特尔(Intel)中央处理器(CPU)产品发展蓝图数据，该数据显示英特尔在2022年之前不会提供10奈米(nm)桌面计算机CPU。然而，英特尔拒绝评论所谓被泄漏的产品蓝图。荷兰IT新闻网站Tweakers发布了据称是英特尔客户端(client)CPU产品蓝图。'
    // },
    // {
    //   img: require('@/assets/images/news.jpg'),
    //   time: {
    //     year: '2019',
    //     month: '06/11'
    //   },
    //   name: 'Wi-Fi 6准备进军智能工厂应用',
    //   detail: '产业组织无线宽带联盟(Wireless Broadband Alliance，WBA)准备在英国一座飞机零件制造厂展示利用最新802.11ax 标准Wi-Fi设备的自动化营运优势，这是该技术几个准备在今年展开的试营运计划中的第一个，将在市场上与5G蜂巢式技术阵营较劲。'
    // },
    // {
    //   img: require('@/assets/images/news.jpg'),
    //   time: {
    //     year: '2019',
    //     month: '06/11'
    //   },
    //   name: '苹果为何不用iPhone XS抢5G首发？',
    //   detail: '根据市场研究公司IC Insights的调查报告，过去几年来，全球半导体产业频繁发生大规模并购的时代可能已经达到高峰了，至少在交易规模方面确实如此。'
    // },
    // {
    //   img: require('@/assets/images/news.jpg'),
    //   time: {
    //     year: '2019',
    //     month: '06/11'
    //   },
    //   name: '苹果为何不用iPhone XS抢5G首发？',
    //   detail: '根据市场研究公司IC Insights的调查报告，过去几年来，全球半导体产业频繁发生大规模并购的时代可能已经达到高峰了，至少在交易规模方面确实如此。'
    // },
    // {
    //   img: require('@/assets/images/news.jpg'),
    //   time: {
    //     year: '2019',
    //     month: '06/11'
    //   },
    //   name: '苹果为何不用iPhone XS抢5G首发？',
    //   detail: '根据市场研究公司IC Insights的调查报告，过去几年来，全球半导体产业频繁发生大规模并购的时代可能已经达到高峰了，至少在交易规模方面确实如此。'
    // },
    // {
    //   img: require('@/assets/images/news.jpg'),
    //   time: {
    //     year: '2019',
    //     month: '06/11'
    //   },
    //   name: '苹果为何不用iPhone XS抢5G首发？',
    //   detail: '根据市场研究公司IC Insights的调查报告，过去几年来，全球半导体产业频繁发生大规模并购的时代可能已经达到高峰了，至少在交易规模方面确实如此。'
    // },
    // {
    //   img: require('@/assets/images/news.jpg'),
    //   time: {
    //     year: '2019',
    //     month: '06/11'
    //   },
    //   name: '苹果为何不用iPhone XS抢5G首发？',
    //   detail: '根据市场研究公司IC Insights的调查报告，过去几年来，全球半导体产业频繁发生大规模并购的时代可能已经达到高峰了，至少在交易规模方面确实如此。'
    // },
    // {
    //   img: require('@/assets/images/news.jpg'),
    //   time: {
    //     year: '2019',
    //     month: '06/11'
    //   },
    //   name: '苹果为何不用iPhone XS抢5G首发？',
    //   detail: '根据市场研究公司IC Insights的调查报告，过去几年来，全球半导体产业频繁发生大规模并购的时代可能已经达到高峰了，至少在交易规模方面确实如此。'
    // }
  ]
}



// WEBPACK FOOTER //
// ./src/EnglishData/sharing.js